export class Configmodel {
    idconf:number;
    refrigerio:number;
    descafp:number;
    desciva:number;
    frontera:number;
    minnacional:number;
    tipocambio:number;
    constructor(idconf=0,refrigerio=0,descafp=0,desciva=0,frontera=0,minnacional=0,tipocambio=0){
        this.idconf=idconf;
        this.refrigerio=refrigerio;
        this.descafp=descafp;
        this.desciva=desciva;
        this.frontera=frontera;
        this.minnacional=minnacional;
        this.tipocambio=tipocambio;
    }
  }